import { useCMSApiQuery } from './useCMSApiQuery';

export function useVendorsMenuQuery(locale: string, enabled: boolean) {
  const result = useCMSApiQuery<VendorsMenu>(
    `/cms/v1/menu-items?PageType=vendors&locale=${locale}`,
    undefined,
    { enabled }
  );
  return result;
}
export type VendorsMenu = {
  menuitems: Vendor[];
  total: number;
};
export type Vendor = {
  isLeftNav: boolean;
  partialPageUrl: string;
  vendorAlias: string;
  vendorName: string;
  vendorPageName: string;
};
